const actions = {
    UPDATE_LOCATION: 'UPDATE_LOCATION',
    UPDATE_LOCATION_SUCCESS: 'UPDATE_LOCATION_SUCCESS',
    UPDATE_LOCATION_ERROR: 'UPDATE_LOCATION_ERROR',
    updateLocation: (deviceIds, clientIds, unAssign, fetchDevicesPayload) => {

        return {
            type: actions.UPDATE_LOCATION,
            payload: {
                deviceIds,
                clientIds,
                unAssign,
                fetchDevicesPayload
            },
        }
    },
    updateLocationSuccess: (data) => ({
        type: actions.UPDATE_LOCATION_SUCCESS,
        data
    }),

}
export default actions;